export function toNiceDate(date: string): string {
  return new Date(date).toISOString().split('.')[0];
}
